import { useQuery, type QueryResult } from '@apollo/client/react';
import { AUTHENTICATION_TYPES } from '@seek/apac-candidate-header-footer/types';

import type { GetUserQuery } from 'src/__generated__/graphql';
import { GET_USER } from 'src/modules/graphql-client/queries/user.graphql';

const getAuthenticationStatus = (user: QueryResult<GetUserQuery>) => {
  if (user.loading) {
    return AUTHENTICATION_TYPES.AUTH_PENDING;
  }

  if (Boolean(user?.data?.viewer?._id)) {
    return AUTHENTICATION_TYPES.AUTHENTICATED;
  }

  return AUTHENTICATION_TYPES.UNAUTHENTICATED;
};

export const useAuth = () => {
  const user = useQuery<GetUserQuery>(GET_USER, {
    errorPolicy: 'all',
  });
  const authenticationStatus = getAuthenticationStatus(user);
  const candidateId = user.data?.viewer?._id;

  return {
    authenticationStatus,
    isAuth: authenticationStatus === AUTHENTICATION_TYPES.AUTHENTICATED,
    isPending: authenticationStatus === AUTHENTICATION_TYPES.AUTH_PENDING,
    candidateId,
    trackingId: user.data?.viewer?.trackingId,
    profileVisibilityId: user.data?.viewer?.profileVisibility2?.id,
    data: user.data,
    loading: user.loading,
    error: user.error,
  };
};
